import { ReactElement } from 'react'

import { RecurringInvoiceDetailsCard } from './elements/RecurringInvoiceDetailsCard'
import { RecurringInvoiceGeneratedDocuments } from './elements/RecurringInvoiceGeneratedDocuments'
import { RecurringInvoiceHistory } from './elements/RecurringInvoiceHistory'
import * as Styled from './styles'

export const RecurringInvoiceViewSidebar = (): ReactElement => {
  return (
    <Styled.RecurringInvoiceViewSidebarWrapper>
      <RecurringInvoiceDetailsCard />
      <RecurringInvoiceGeneratedDocuments />
      <RecurringInvoiceHistory />
    </Styled.RecurringInvoiceViewSidebarWrapper>
  )
}
